module.exports = __webpack_public_path__ + "img/photo_ilona.83948bc6.png";